import { render, staticRenderFns } from "./home.vue?vue&type=template&id=46c18460&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=46c18460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c18460",
  null
  
)

export default component.exports